// extracted by mini-css-extract-plugin
export var labelWrapper = "_9k-0";